// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","banner":"banner_banner_2DzPg","bannerInfo":"banner_bannerInfo_3fMlu","orange":"banner_orange_2Hsag","lato-cover":"banner_lato-cover_3bVdV global lato-cover","lato-cover-thin":"banner_lato-cover-thin_11qgZ global lato-cover","shadowCircle":"banner_shadowCircle_2Nlan","a":"banner_a_1BkjC","getInTouchContainer":"banner_getInTouchContainer_28_GC","getInTouch":"banner_getInTouch_3U9Kl"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/banner/banner.css
// module id = 401
// module chunks = 4